import { render, staticRenderFns } from "paraview-lite/src/modules/Default/template.html?vue&type=template&id=69d9cba8&"
import script from "paraview-lite/src/modules/Default/script.js?vue&type=script&lang=js&"
export * from "paraview-lite/src/modules/Default/script.js?vue&type=script&lang=js&"
import style0 from "paraview-lite/src/modules/commonStyles.css?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports